exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".visual-box[data-v-5eddecf7]{height:60px;width:60px;border:2px solid #006aff;border-radius:4px;margin:auto auto 20px;display:-webkit-box;display:-ms-flexbox;display:flex;color:#006aff;font-weight:600;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.component-visual[data-v-5eddecf7]{color:#006aff;margin-bottom:30px;text-align:center}", ""]);

// exports
